import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageAliasComponent } from './manage-alias.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { DesignUtilitiesModule } from 'src/app/appModules/design-utilities.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ManageAliasComponent],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    DesignUtilitiesModule,
  ],
  exports: [ManageAliasComponent, TranslateModule],
})
export class ManageAliasModule {}
